import { useEffect, useRef } from "react";
import { useIsMobile } from "@hooks";
import useAppStore from "../../../stores/appStore";
import { assistantIdSelector } from "../../../stores/selectors/appSelectors";
import { getInsightsDashboardKey } from "./ResponsiveIframe.utils";
import { LOOKER_ORIGIN, MESSAGE_TYPES } from "./ResponsiveIframe.consts";

const useResponsiveIframe = () => {
  const isMobile = useIsMobile();
  const iframeRef = useRef(null);
  const assistantId = useAppStore(assistantIdSelector);
  const dashboardKey = getInsightsDashboardKey(assistantId);

  const updateFilters = (filters) => {
    if (iframeRef.current?.contentWindow) {
      const message = {
        type: MESSAGE_TYPES.DASHBOARD_FILTERS_UPDATE,
        filters: JSON.parse(filters)
      };
      iframeRef.current.contentWindow.postMessage(JSON.stringify(message), LOOKER_ORIGIN);
      const runMessage = {
        type: MESSAGE_TYPES.DASHBOARD_RUN
      };
      iframeRef.current.contentWindow.postMessage(JSON.stringify(runMessage), LOOKER_ORIGIN);
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.source === iframeRef.current?.contentWindow) {
        if (event.origin === LOOKER_ORIGIN) {
          const data = JSON.parse(event.data);
          if (data.type === MESSAGE_TYPES.DASHBOARD_LOADED) {
            setTimeout(() => updateFilters(sessionStorage.getItem(dashboardKey)));
          }
          if (data.type === MESSAGE_TYPES.DASHBOARD_FILTERS_CHANGED && data.dashboard.dashboard_filters) {
            sessionStorage.setItem(dashboardKey, JSON.stringify(data.dashboard.dashboard_filters));
          }
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [dashboardKey]);

  return {
    isMobile,
    iframeRef
  };
};

export default useResponsiveIframe;
